// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__3CHQS","full":"loader_full__12tcq","loaderWrapper":"loader_loaderWrapper__1zNDe","label":"loader_label__1mmIg"};